export default "__VITE_ASSET__D4PxIm11__"